module.exports = __webpack_public_path__ + "img/50.e18501ac.jpg";